module.exports = __webpack_public_path__ + "2ef8c3eb.svg";